import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import config from '../config/config';
import { isSocialLogin, isEmpty, deepClone } from '../helpers';
import isPage from '../hoc/isPage';

class LoginContainer extends React.Component {
    static propTypes = {
        onSuccessUrl: PropTypes.string, // where to go if the login succeeds
        onFailUrl: PropTypes.string, // where to go if the login fails
        onFail: PropTypes.func, // what to do if the login attempt fails
        forceResetProps: PropTypes.bool // on login, force all properties stored in context state to be reset so we can start from a fresh slate
    }
    state = {
        isPending: true, // data load still happening?
        error: false // did an error happen while data loading?
    }
    componentDidMount() {

        // do a call to the /GetUser endpoint
        this.props.getData(`/api/portal/user/GetUser`)
            .then(response => {

                const { email/*, orgID*/ } = response.data;

                // now we need to determine if we're logged in as someone different from the last user.
                // if so, then we need to reset the "preserved properties" in context state
                if ((email !== this.context.state.email) || this.props.forceResetProps) {

                    // clear out context state, since now we're dealing with a new user
                    this.context.resetPreservedState(() => {
                        // also clear out the list of child dealers and report groups, since the new user may have different data for these properties
                        this.context.setState({
                            childDealerships: [],
                            reportGroups: []
                        }, () => {
                            this.saveUserDetails(response.data);
                        })

                    });

                } else {
                    this.saveUserDetails(response.data);
                }

                this.setState({
                    isPending: false,
                })
            })
            .catch(e => {

                this.setState({
                    isPending: false,
                    error: true
                })
            })
            .then(() => {
                this.props.getData(`/api/portal/uiLanguage/Get?browserLanguage=${navigator.language.slice(0, 2)}`)
                    .then(response => {
                        //console.log(response.data)
                        this.context.setLanguage(response.data);
                        //console.log(this.context.state.uiLanguage)
                    })
            })

    }

    // take results of data pull from /user/GetUser and save it to context
    saveUserDetails = (data) => {

        let orgType = data.orgType.toLowerCase();
        //debugger;

        if (!isEmpty(config.spoofedOrgType)) {
            orgType = config.spoofedOrgType;
        }

        // begin of FreshDesk
        //window.FreshWidget.init("",
        //    {
        //        "queryString": `&widgetType=popup&submitTitle=Send&submitThanks=Hang+in+there!+We+will+be+in+touch+shortly&captcha=yes&helpdesk_ticket[requester]=${data.email}&helpdesk_ticket[custom_field][user_id]=${data.userID}&helpdesk_ticket[custom_field][language_code]=${data.languageCode}&helpdesk_ticket[custom_field][first_name]=${data.firstName}&helpdesk_ticket[custom_field][last_name]=${data.lastName}`,
        //        "utf8": "?",
        //        "widgetType": "popup",
        //        "buttonType": "text",
        //        "buttonText": {this.props.returnLocalizedString("m0460")},
        //        "buttonColor": "white",
        //        "buttonBg": "#009CEF",
        //        "alignment": "2",
        //        "offset": "500px",
        //        "submitThanks": this.props.returnLocalizedString("m0459"),
        //        "formHeight": "500px",
        //        "captcha": "yes",
        //        "url": "https://thesuperco.freshdesk.com"
        //    });
        // end of FreshDesk
        // begin of FreshChat
        //if (window.fcWidget) {
        //    if (!isEmpty(data.email)) {
        //        window.fcWidget.user.setEmail(data.email);
        //    }
        //    if (!isEmpty(data.userID)) {
        //        window.fcWidget.setExternalId(data.userID);
        //    }
        //    if (!isEmpty(data.firstName)) {
        //        window.fcWidget.user.setFirstName(data.firstName);
        //    }
        //    if (!isEmpty(data.lastName)) {
        //        window.fcWidget.user.setLastName(data.lastName);
        //    }
        //    if (!isEmpty(data.languageCode)) {
        //        window.fcWidget.user.setLocale(data.languageCode);
        //    }
        //}
        // end of FreshChat

        // get the navlinks appropriate for the user's org type.
        let links = deepClone(config.navLinks[orgType]);

        //console.log('original list of links', links);

        let roles = data.roles;
        if (!isEmpty(config.spoofedRole)) {
            roles = config.spoofedRole;
        }

        // check if we need to insert admin link
        if (roles.includes("superadmin")) {
            links.push({
                icon: "admin2",
                label: "m0461",
                //link: '/admin',
                //exact: true,
                submenu: [
                    { icon: "MO", label: "m0457", link: "/admin", exact: true },
                    { icon: "US", label: "m0458", link: "/admin/org/users", linkParams: "?roleID=572180F3-3F48-4523-B547-2B134FCB05CF&role=superadmin" },
                    { icon: "AR", label: "m0381", link: "/admin/reports", linkParams: "?roleID=572180F3-3F48-4523-B547-2B134FCB05CF&role=superadmin" }
                ]
            });
        }

        if (["dealer", "dealergroup"].includes(orgType)) {
            if (data.allowEditSuggestedOrders) {

                const partSeasonsMenuLink = {
                    icon: "PS",
                    label: "m0298",
                    link: "/settings/part-seasons"
                }

                const partExceptionsMenuLink = {
                    icon: "PE",
                    label:"m0276",
                    link: "/settings/part-exceptions"
                }

                // search for a Settings menu link
                let settingsLink = links.find(link => link.label.match(/^m0279$/i));
                if (settingsLink) {

                    // search for a submenu
                    let submenu = settingsLink.submenu;

                    // if submenu exists, then just append the link
                    if (submenu) {
                        submenu.push(partSeasonsMenuLink);
                        submenu.push(partExceptionsMenuLink);

                        // otherwise, create the submenu and then append the link
                    } else {
                        settingsLink.submenu = [partSeasonsMenuLink, partExceptionsMenuLink];

                    }
                } else {
                    // create settings link
                    //links.push({
                    //    icon: "settings2",
                    //    label: "m0279",
                    //    submenu: [partSeasonsMenuLink, partExceptionsMenuLink]
                    //})
                    links.splice(4, 0, {
                        icon: "settings2",
                        label: "m0279",
                        submenu: [partSeasonsMenuLink, partExceptionsMenuLink]
                    })
                }
            }
        }

        // check if the user is one of "superadmin" or "admin"
        // if so, we want to add a "user management" tab
        if (roles.some(r => ["superadmin", "admin"].includes(r))) {

            const userManagementMenuLink = {
                icon: "UM",
                label: "m0462",
                link: "/settings/users"
            }

            // search for a Settings menu link
            let settingsLink = links.find(link => link.label.match(/^m0279$/i));
            //console.log(links.find(link => link.label.match(/^m0279$/i)))
            if (settingsLink) {

                // search for a submenu
                let submenu = settingsLink.submenu;

                // if submenu exists, then just append the link
                if (submenu) {
                    submenu.push(userManagementMenuLink);

                    // otherwise, create the submenu and then append the link
                } else {
                    settingsLink.submenu = [userManagementMenuLink];

                }
            } else {
                // create settings link
                //links.push({
                //    icon: "settings2",
                //    label: "m0279",
                //    submenu: [userManagementMenuLink]
                //})
                links.splice(4, 0, {
                    icon: "settings2",
                    label: "m0279",
                    submenu: [userManagementMenuLink]
                })
            }
        }

        links.forEach((link, i) => {
            if (link.submenu) {
                link.submenu.forEach(sm => { sm.parentIdx = i; });
            }
        });


        // save the email address in local storage so that when the user logs in next time, we can pre-populate the Auth0 email address
        // only do this if the user is logging in via email/password
        if (!isSocialLogin(data.subjectClaim)) {
            localStorage.setItem("somLoginEmail", data.email);
        } else {
            localStorage.removeItem("somLoginEmail");
        }


        this.context.setState({
            orgType: orgType,
            orgCode: data.orgCode,
            firstName: data.firstName,
            lastName: data.lastName,
            userName: `${data.firstName} ${
                data.lastName
                }`,
            orgID: data.orgID,
            orgName: data.orgName,
            languageCode: data.languageCode,
            currencySymbol: data.currencySymbol,
            currencyCode: data.currencyCode,
            email: data.email,
            subjectClaim: data.subjectClaim,
            navLinks: links,
            roles,
            hasParent: data.hasParent,
            userID: data.userID,
            allowEditSuggestedOrders: data.allowEditSuggestedOrders
        });
    }

    render() {

        //!DBTRANS! @m0298@ Part Seasons !DEVNOTE! Title
        //!DBTRANS! @m0276@ Part Exceptions !DEVNOTE! Title
        //!DBTRANS! @m0279@ Settings !DEVNOTE! Option label
        //!DBTRANS! @m0381@ Admin reports !DEVNOTE! Title

        //!DBTRANS! @m0457@ Manage orgs !DEVNOTE! Page Label
        //!DBTRANS! @m0458@ Manage superadmins !DEVNOTE! Page Label
        //!DBTRANS! @m0459@ Hang in there! We will be in touch shortly !DEVNOTE! 
        //!DBTRANS! @m0460@ Support !DEVNOTE! Page Label
        //!DBTRANS! @m0461@ Admin !DEVNOTE! Page Label
        //!DBTRANS! @m0462@ User management !DEVNOTE! Page Label

        if (this.state.isPending) {
            return (
                <React.Fragment />
            )
        } else if (this.state.error) {

            if (this.props.onFail) {
                this.props.onFail()
                return (
                    <React.Fragment />
                )
            } else {
                //this.context.logout();

                return (
                    <Redirect to={this.props.onFailUrl} />
                )
                //return (
                //    <React.Fragment />
                //)
            }

        } else {
            //console.log(`redirecting to ${this.props.onSuccessUrl}`)
            return (
                <Redirect to={{
                    pathname: this.props.onSuccessUrl
                }} />
            )
        }


    }
}
LoginContainer.defaultProps = {
    onSuccessUrl: config.loginSuccessUrl,
    onFailUrl: config.loginFailUrl
}

export default isPage(LoginContainer);
LoginContainer.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/components/LoginContainer.js